import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { Bell } from "lucide-react";
import { AnnouncementBody, isRich } from "@/components/AnnouncementBody";

const PRIORITY = {
  important: { key: "priority.important", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  reminder: { key: "priority.reminder", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  action: { key: "priority.action", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  completed: { key: "priority.completed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  new: { key: "priority.new", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  travel: { key: "priority.travel", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  // backward compatibility with earlier data
  high: { key: "priority.important", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

function formatDate(dateStr, lang) {
  if (!dateStr) return "";
  try {
    return new Date(dateStr).toLocaleDateString(lang === "fr" ? "fr-FR" : "en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
}

export const LatestUpdates = ({ announcements = [], innerRef }) => {
  const { L, t, lang } = useLang();

  return (
    <section ref={innerRef} className="scroll-mt-4" data-testid="latest-updates">
      <div className="mb-5 flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-2xl bg-[#0A192F] text-[#E9CE7D]">
          <Bell size={18} strokeWidth={1.75} />
        </span>
        <div>
          <h2 className="font-display text-xl font-bold tracking-tight text-[#0A192F] leading-none">{t("latestUpdates")}</h2>
          <p className="mt-1 text-xs text-slate-500">{t("checkHere")}</p>
        </div>
      </div>

      <div className="stagger space-y-3.5">
        {announcements.map((a) => {
          const p = PRIORITY[a.priority] || PRIORITY.new;
          return (
            <article
              key={a.id}
              data-testid={`announcement-${a.id}`}
              className="maqam-card p-5 border-l-4 border-l-[#D4AF37]"
            >
              <div className="mb-2 flex items-center gap-2.5">
                <span
                  className={`rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide ${p.cls}`}
                >
                  {t(p.key)}
                </span>
                <span className="text-[11px] font-medium text-slate-400">{formatDate(a.date, lang)}</span>
              </div>
              <h3 className="font-display text-base font-bold leading-snug text-[#0A192F]">{L(a.title)}</h3>
              {isRich(L(a.body)) ? (
                <AnnouncementBody body={L(a.body)} testId={`announcement-${a.id}-body`} />
              ) : (
                <p className="mt-1.5 whitespace-pre-line text-sm leading-relaxed text-slate-600">{L(a.body)}</p>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
};
